var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _g, _path11, _path12, _path13, _path14, _path15, _path16, _g2, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _g3, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _g4, _g5, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _g6, _g7, _g8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHomeimage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 910,
    height: 513.171,
    viewBox: "0 0 910 513.171",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -211.713,
    y1: 0.975,
    x2: -211.008,
    y2: 0.025,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.273,
    stopColor: "#eceef7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#9c9aa8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -301.914,
    y1: 0.812,
    x2: -302.41,
    y2: 0.235,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.262,
    stopColor: "#393843"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.781,
    stopColor: "#23222e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: -898.031,
    y1: 0.441,
    x2: -899.214,
    y2: 0.585,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#adaeb8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.076,
    stopColor: "#babbc5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.199,
    stopColor: "#c9cbd3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.342,
    stopColor: "#d2d4dc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.549,
    stopColor: "#d5d7df"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.662,
    stopColor: "#c0c1ca"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#868490"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: -722.671,
    y1: 0.568,
    x2: -723.44,
    y2: 0.435,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: -368.374,
    y1: 0.721,
    x2: -368.601,
    y2: 0.198,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: -223.392,
    y1: 0.975,
    x2: -222.687,
    y2: 0.025,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: -318.577,
    y1: 0.812,
    x2: -319.073,
    y2: 0.235,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: -947.427,
    y1: 0.441,
    x2: -948.611,
    y2: 0.585,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: -762.384,
    y1: 0.568,
    x2: -763.154,
    y2: 0.435,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: -388.714,
    y1: 0.721,
    x2: -388.941,
    y2: 0.198,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 1,
    y1: 0.234,
    x2: 0.059,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Home-image",
    transform: "translate(-29.832 -409.41)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_143",
    "data-name": "Group 143",
    transform: "translate(89.539 409.41)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_140",
    "data-name": "Group 140"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_495",
    "data-name": "Path 495",
    d: "M203.387,496.486,561.458,705.279s36.588,18.481,72.854,20.866,67.769-13.757,89.783-23.808,72.693-39.22,83.215-49.052,39.369-30.589,10.832-58.557S364.053,348.559,326.218,347.019,173.045,442.256,170.132,459.087C167.362,475.115,182.073,484.177,203.387,496.486Z",
    transform: "translate(-169.797 -243.781)",
    opacity: 0.29
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_496",
    "data-name": "Path 496",
    d: "M374.848,409.654l-11.706-1.161s-48.817,33.8-88.1,49.15,5.166-18.383,17.82-27.032,79.963-41.312,81.985-36.088S374.848,409.654,374.848,409.654Z",
    transform: "translate(254.42 -20.883)",
    fill: "#9099af"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_497",
    "data-name": "Path 497",
    d: "M192.638,454.027l33.4-21.8,91.479,59.919L495.939,632.715l23.394-19.866,76.371,45.42,5.017-134.624L192.638,349.538S158.32,369.358,192.638,454.027Z",
    transform: "translate(-133.775 -231.738)",
    fill: "#131313"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_498",
    "data-name": "Path 498",
    d: "M256.478,426.481c0,22.641-16,31.767-35.738,20.371s-35.732-38.99-35.732-61.637,16-31.767,35.732-20.377S256.478,403.828,256.478,426.481Z",
    transform: "translate(-97.592 -182.396)",
    fill: "#333"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_499",
    "data-name": "Path 499",
    d: "M233.724,460.714l23.157-13.367-50.862-86.977-23.292,13.446Z",
    transform: "translate(-108.43 -180.327)",
    fill: "#333"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_500",
    "data-name": "Path 500",
    d: "M252.4,428.828c0,22.653-16,31.778-35.738,20.377s-35.732-38.99-35.732-61.637,16-31.773,35.732-20.371S252.4,406.187,252.4,428.828Z",
    transform: "translate(-116.929 -171.232)",
    fill: "#3e3e3e"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_501",
    "data-name": "Path 501",
    d: "M309.258,456.948c0,22.653-16,31.773-35.738,20.377s-35.732-38.99-35.732-61.637,16-31.772,35.732-20.371S309.258,434.307,309.258,456.948Z",
    transform: "translate(152.929 -37.761)",
    fill: "#333"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_502",
    "data-name": "Path 502",
    d: "M286.5,491.186l23.154-13.362L258.8,390.841l-23.292,13.452Z",
    transform: "translate(142.09 -35.693)",
    fill: "#333"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_139",
    "data-name": "Group 139",
    transform: "translate(16.304)"
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_503",
    "data-name": "Path 503",
    d: "M261.141,380.574a13.6,13.6,0,0,0,.431,3.873c0,.063.029.092.029.144a2.455,2.455,0,0,0,.546.948,5.081,5.081,0,0,0,.684.575,12.735,12.735,0,0,0,5.31,2.35,9.661,9.661,0,0,0,2.586.121h.029a1.525,1.525,0,0,0,.489-.057h.029a8.584,8.584,0,0,0,2.862-.891c.207-.115.437-.23.666-.374h.029c.23-.115.454-.264.684-.4,0,0,.035,0,.035-.029,4.3-2.643,9.321-7.66,11.476-12.079a11.6,11.6,0,0,0,.741-1.983,14.189,14.189,0,0,0,.488-2.494,4.733,4.733,0,0,0,.057-.6,16.565,16.565,0,0,0,.115-2.005,11.891,11.891,0,0,0-.058-1.465,4.381,4.381,0,0,0-.086-.862,13.852,13.852,0,0,0-.517-2.724.235.235,0,0,0-.029-.086,8.457,8.457,0,0,0-2.408-4.39,4.083,4.083,0,0,0-3.356-.919c-2.839.345-6.976,2.839-13.947,7.574a16.97,16.97,0,0,0-6.482,8.5l-.092.259a8.921,8.921,0,0,0-.2,1.454c0,.667-.058,1.437-.086,2.212v.029C261.141,378.338,261.112,379.488,261.141,380.574Z",
    transform: "translate(247.408 -195.493)",
    fill: "#eeeef0"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_504",
    "data-name": "Path 504",
    d: "M262.12,375.17v.942l.023.029a.3.3,0,0,0,0,.2,14.759,14.759,0,0,0,1.034,5.568v.029l.029.029a4.935,4.935,0,0,0,2.437,2.781,5.377,5.377,0,0,0,4.419-.259v-.023a6.424,6.424,0,0,0,.747-.345s.035,0,.035-.029a26.229,26.229,0,0,0,11.476-12.079,11.6,11.6,0,0,0,.741-1.983,11.2,11.2,0,0,0,.488-2.327v-.167a4.733,4.733,0,0,0,.057-.6,16.578,16.578,0,0,0,.115-2.005,11.89,11.89,0,0,0-.058-1.465,3.414,3.414,0,0,0-.057-.776v-.023a11.07,11.07,0,0,0-.546-2.787.235.235,0,0,0-.029-.086c-.431-1.2-1.034-1.9-1.661-2.011a4.694,4.694,0,0,0-1.379.057,22.382,22.382,0,0,0-9.3,4.534C267.252,365.3,262.235,368.659,262.12,375.17Z",
    transform: "translate(252.112 -192.756)",
    fill: "#efeef0"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_119",
    "data-name": "Group 119",
    transform: "translate(168.465 1.537)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_505",
    "data-name": "Path 505",
    d: "M673.7,684.175s-3.689,2.908-6.856,2.293-26.917-14.424-26.917-14.424l-1.212-.655V660.9c0-25.905-18.308-57.477-40.881-70.51-18.228-10.528-33.663-5.752-38.938,10.108a41.89,41.89,0,0,0-1.942,13.2v13.93l-3.436-1.839-218.1-125.929V485.788a69.427,69.427,0,0,0-3.1-19.728c-6.137-20.549-20.739-40.938-37.778-50.776-22.578-13.039-40.881-2.6-40.881,23.3v8.924l-40.749-32.146-6.988-17.958v-8.172l1.454-2.942v-6.051L205,377.208l-3.046-8.683,5.408-7.166s.919-14.6,1.58-18.153c.448-2.419-.506-6.126,1.167-9.43l.006-.012c.776-1.546,4.517-4.385,4.89-4.453a1.669,1.669,0,0,1,.529.075c3.948.965,34.611,10.683,34.611,10.683s6.333,1.236,18.113,2.994,49.213,4.246,59.063,7.3,47.294,20.251,85.8,43.886,54.558,40.076,59.086,44.283c26.779,24.848,72.262,73.883,78.244,81.175,10.551,8.1,96.007,65.2,107.437,92.186,2.638,7.769,8.787,31.9,8.787,31.9l4.746,8.384v5.453l-2.988,4.126,2.115,14.734Z",
    transform: "translate(-201.95 -329.306)",
    fill: "#e7e7e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_506",
    "data-name": "Path 506",
    d: "M673.7,662.811s-3.689,2.908-6.856,2.293-26.917-14.424-26.917-14.424l-1.212-.655V639.537c0-25.905-18.308-57.477-40.881-70.51-18.228-10.528-33.663-5.752-38.938,10.108a41.89,41.89,0,0,0-1.942,13.2v13.93l-3.436-1.839L335.418,478.5V464.424a69.427,69.427,0,0,0-3.1-19.728c-6.137-20.549-20.739-40.938-37.778-50.776-22.578-13.039-40.881-2.6-40.881,23.3v8.924L212.909,394l-6.988-17.958v-8.172l1.454-2.942v-6.051L205,355.843l-3.046-5.953s14.085,3.8,15.314,2.689,25.141-19.377,28.307-18.757S335.43,387.139,369.346,407.3s163.7,101.949,210.61,133.813c53.615,36.416,53.615,56.563,65.252,77.911,1.011,1.845,23.222,21.365,23.222,21.365l2.115,14.734Z",
    transform: "translate(-201.95 -307.941)",
    fill: "#d2d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_507",
    "data-name": "Path 507",
    d: "M241.348,341.456c-18.464-7.229-30.422.2-30.951,30.962,22.509-13.843,28.664-18.033,49.587-.471s35.864,40.938,35.864,40.938S288.291,361.1,241.348,341.456Z",
    transform: "translate(-161.856 -283.773)",
    fill: "#d2d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_508",
    "data-name": "Path 508",
    d: "M451.221,497.483a41.891,41.891,0,0,0-1.943,13.2v13.93l-3.436-1.839-218.1-125.929V382.771a69.424,69.424,0,0,0-3.1-19.728c1.092-4.057,1.781-6.6,1.781-6.6a20.542,20.542,0,0,1,1.845-1.04c4.31-2.241,15.723-6.947,28.75-2.632,16.613,5.511,162.983,99.7,173.8,107.6,7.855,5.747,13.211,4.7,17.67,22.728C449.428,486.944,450.342,491.651,451.221,497.483Z",
    transform: "translate(-94.271 -226.289)",
    fill: "#bec2d1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509",
    "data-name": "Path 509",
    d: "M262.327,364.581l-33.755-7.689,11.866,12L411.92,471.983S395.33,452.112,385.136,446,262.327,364.581,262.327,364.581Z",
    transform: "translate(-75.588 -198.37)",
    fill: "#efeef0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510",
    "data-name": "Path 510",
    d: "M332.139,443.612V429.538a69.425,69.425,0,0,0-3.1-19.728c-6.137-20.55-20.739-40.938-37.778-50.776-22.578-13.039-40.881-2.6-40.881,23.3v8.924l-40.749-32.146-6.988-17.958,7.12,7.218,33.922,23.59c2.8-25.676,23.032-35.169,47.575-21,17.665,10.206,33.1,30.083,41.4,51.207,4.138,10.516,6.505,21.337,6.505,31.433v4.316L546.644,561.208v-7.821c0-9.867,2.258-17.814,6.235-23.52,8.229-11.884,23.814-14.108,41.68-3.793,26.457,15.274,47.909,52.27,47.909,82.641l.873,3.522,27.083,15.688s-3.689,2.908-6.856,2.293-26.917-14.424-26.917-14.424l-1.212-.655V604.652c0-25.905-18.308-57.477-40.881-70.51-18.228-10.528-33.663-5.752-38.938,10.108a41.892,41.892,0,0,0-1.943,13.2v13.93l-3.436-1.839Z",
    transform: "translate(-198.67 -273.056)",
    fill: "#9099af"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_511",
    "data-name": "Path 511",
    d: "M297.02,373.936C356.778,411.5,535.971,526.069,535.971,526.069s68.292,42.656,79.239,54.575,26.164,40.593,28.8,45.3,15.923,17.786,15.923,17.786-6.149-24.13-8.787-31.9c-11.43-26.986-96.886-84.083-107.437-92.186-5.982-7.292-51.466-56.327-78.244-81.175-4.528-4.206-20.584-20.636-59.086-44.283s-75.957-40.823-85.8-43.886-47.282-5.545-59.063-7.3S243.4,340,243.4,340s-30.663-9.717-34.611-10.683a57.511,57.511,0,0,1-5.419,4.379l-.006.012S250.789,344.864,297.02,373.936Z",
    transform: "translate(-195.215 -329.24)",
    fill: "#efeef0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_512",
    "data-name": "Path 512",
    d: "M283.318,410.986c0,22.647-16,31.767-35.738,20.371s-35.737-38.99-35.737-61.637,16-31.767,35.737-20.371S283.318,388.339,283.318,410.986Z",
    transform: "translate(-154.993 -257.469)",
    fill: "#3e3e3e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_513",
    "data-name": "Path 513",
    d: "M268.628,397.81c0,17.55-12.4,24.612-27.692,15.786s-27.692-30.215-27.692-47.759,12.4-24.624,27.692-15.8S268.628,380.255,268.628,397.81Z",
    transform: "translate(-148.348 -248.936)",
    fill: "#d9d9d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_514",
    "data-name": "Path 514",
    d: "M336.092,441.459c0,22.647-16,31.772-35.732,20.371s-35.738-38.99-35.738-61.631,16-31.772,35.738-20.377S336.092,418.811,336.092,441.459Z",
    transform: "translate(95.528 -112.834)",
    fill: "#3e3e3e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_515",
    "data-name": "Path 515",
    d: "M321.413,428.279c0,17.544-12.4,24.618-27.692,15.792s-27.7-30.215-27.7-47.771,12.4-24.612,27.7-15.786S321.413,410.729,321.413,428.279Z",
    transform: "translate(102.168 -104.297)",
    fill: "#d9d9d9"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_118",
    "data-name": "Group 118",
    transform: "translate(99.972 43.77)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_516",
    "data-name": "Path 516",
    d: "M457.971,572.743l-1.081-.649c-1.666-.994-166.534-99.679-177.136-105.954-10.292-6.08-15.274-16.751-17.671-21.877l-.414-.891c-2.1-4.408-25.859-60.264-26.865-62.643l-15.458-39.3,1.218-4.505,19.377,2.46.155.1L443.363,467.133l8.281,15.969,6.212,16.516s2.58,22.538,3.637,31.422-3.166,39.168-3.344,40.45ZM221.105,341.336l15.246,38.76c.241.557,24.75,58.183,26.825,62.556l.425.9c2.321,4.971,7.16,15.326,17,21.147,10.154,6,161.638,96.674,176.056,105.3.8-5.919,4.08-31.1,3.172-38.772-1.017-8.528-3.437-29.669-3.626-31.324l-6.085-16.125-8.034-15.475L239.368,341l-17.573-2.23Z",
    transform: "translate(-219.347 -336.923)",
    fill: "#878788"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_517",
    "data-name": "Path 517",
    d: "M276.279,374.14l23.59,15.59s2.218,9.189,4.591,16.918,4.356,18.55,4.356,18.55-10.269-12.022-10.666-13.16-19.119-33.284-19.119-33.284Z",
    transform: "translate(150.853 -116.502)",
    fill: "#d9d9d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_518",
    "data-name": "Path 518",
    d: "M205.3,331.152l14.535,3.411,22,9.176-3.853,5.107-10.719,7.222-17.225-6.42-6.417-4.758-1.207-9.546Z",
    transform: "translate(-199.789 -320.543)",
    fill: "#dee0df"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_519",
    "data-name": "Path 519",
    d: "M242.292,376.3s-33.06-23.124-34.991-25.049-4.66-5.1-4.66-5.1v-6.413l10.286,8.511,12.66,10.338,2.816,4.649Z",
    transform: "translate(-198.67 -279.806)",
    fill: "#d2d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_520",
    "data-name": "Path 520",
    d: "M302.181,405.181a60.776,60.776,0,0,1-13.8-7.252c-7.741-5.275-8.643-16.584-8.643-16.584L297.435,396.8Z",
    transform: "translate(167.286 -82.308)",
    fill: "#efeef0"
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path_521",
    "data-name": "Path 521",
    d: "M396.75,343.061,219.133,445.606l-18.112-3-26.143-15.966L343.5,329.307l35.139,10.757Z",
    transform: "translate(-161.981 -327.766)",
    fill: "#efeef0"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Path_522",
    "data-name": "Path 522",
    d: "M360.2,331.7l59.062,7.3L263,429.217l-80.424,5.028Z",
    transform: "translate(-125.428 -316.405)",
    fill: "#efeef0"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Path_523",
    "data-name": "Path 523",
    d: "M456.284,429.489,284.773,528.509l-62.985-89.985,156.256-90.211Z",
    transform: "translate(60.676 -237.55)",
    fill: "#efeef0"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Path_524",
    "data-name": "Path 524",
    d: "M341.463,511.349l156.256-90.21-49.993-36.213-94.9-51.955L196.575,423.187Z",
    transform: "translate(-58.999 -310.375)",
    fill: "#efeef0"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Path_525",
    "data-name": "Path 525",
    d: "M404.26,362.44,232.749,461.46l110.488,90.424L511.7,454.625l-12.621-20.04Z",
    transform: "translate(112.7 -170.501)",
    fill: "#efeef0"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Path_526",
    "data-name": "Path 526",
    d: "M265.84,514.387,434.3,417.129l.05-3.244-2.245-28.318L260.565,491.973l-8.177,5.954Z",
    transform: "translate(205.922 -60.724)",
    fill: "#d2d3d4"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_131",
    "data-name": "Group 131",
    transform: "translate(0 98.797)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_527",
    "data-name": "Path 527",
    d: "M644.394,701.1s-3.689,2.913-6.856,2.3-36.071-9.137-36.071-9.137l-1.218-.655V683.114c0-25.905-18.3-57.471-40.881-70.51-18.228-10.522-33.657-5.752-38.933,10.108a41.733,41.733,0,0,0-1.942,13.2v13.93L515.057,648,296.948,522.074V508.007a69.371,69.371,0,0,0-3.1-19.734c-6.131-20.55-20.739-40.944-37.778-50.782-22.572-13.027-40.875-2.6-40.875,23.308v8.924l-34.646-35.669L173.559,416.1v-8.172l1.448-2.942v-6.057l-2.373-3.034V385.457l5.407-7.172s.925-14.6,1.58-18.153a57.6,57.6,0,0,1,4.224-11.194l.006-.006c.776-1.552,1.465-2.626,1.839-2.7a1.488,1.488,0,0,1,.523.075c3.954.971,25.463,15.97,25.463,15.97s6.327,1.23,18.107,2.994,70.579-8.085,80.428-5.028,47.3,20.245,85.8,43.892S450.57,444.2,455.1,448.409c26.773,24.848,57,82.692,62.982,89.985,10.55,8.108,99.058,63.447,110.488,90.421,2.638,7.775,8.792,31.9,8.792,31.9l4.747,8.39v5.448l-2.988,4.126,2.115,14.74Z",
    transform: "translate(-172.634 -346.231)",
    fill: "#e7e7e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_528",
    "data-name": "Path 528",
    d: "M644.394,675.364s-3.689,2.913-6.856,2.3-36.071-9.137-36.071-9.137l-1.218-.655V657.383c0-25.905-18.3-57.471-40.881-70.51-18.228-10.522-33.657-5.752-38.933,10.108a41.733,41.733,0,0,0-1.942,13.2v13.93l-3.436-1.845L296.948,496.343V482.276a69.371,69.371,0,0,0-3.1-19.733c-6.131-20.55-20.739-40.944-37.778-50.782-22.572-13.027-40.875-2.6-40.875,23.308v8.924l-34.646-35.669-6.988-17.958v-8.172l1.448-2.942V373.2l-2.373-3.034v-7.717s7.982,7.333,9.212,6.224,22.1-17.613,25.262-17,89.852,53.322,123.774,73.475S494.571,527.1,541.491,558.963c53.615,36.416,53.615,56.563,65.252,77.911,1.006,1.85,32.376,16.079,32.376,16.079l2.115,14.74Z",
    transform: "translate(-172.634 -320.5)",
    fill: "#d2d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_529",
    "data-name": "Path 529",
    d: "M420.318,515.329a41.732,41.732,0,0,0-1.942,13.2v13.93l-3.436-1.845L196.83,414.691V400.623a69.373,69.373,0,0,0-3.1-19.734c1.092-4.063,1.787-6.6,1.787-6.6a20.455,20.455,0,0,1,1.839-1.046c4.316-2.23,15.722-6.948,28.75-2.626,16.619,5.505,162.988,99.7,173.8,107.6,7.861,5.746,13.211,4.695,17.676,22.728C418.525,504.79,419.433,509.5,420.318,515.329Z",
    transform: "translate(-72.516 -238.848)",
    fill: "#bec2d1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_530",
    "data-name": "Path 530",
    d: "M216.577,358.573c-18.458-7.229-37.174,10.229-37.7,40.99,16.935-24.963,30.238-25.658,53.115-10.734,30.2,19.7,41.61,62.148,41.61,62.148S278.024,386.11,216.577,358.573Z",
    transform: "translate(-143.016 -295.367)",
    fill: "#e7e7e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_531",
    "data-name": "Path 531",
    d: "M231.424,382.42l-33.761-7.683L209.53,386.73l171.488,103.1s-16.6-19.872-26.79-25.986S231.424,382.42,231.424,382.42Z",
    transform: "translate(-53.834 -210.927)",
    fill: "#e7e7e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_532",
    "data-name": "Path 532",
    d: "M296.184,464.366V450.3a69.37,69.37,0,0,0-3.1-19.734c-6.132-20.55-20.739-40.944-37.778-50.782-22.572-13.027-40.875-2.6-40.875,23.308v8.924l-26.595-23.727-8.051-11.941L172.8,358.389l10.286,15.889,24.647,18.44c2.8-25.675,23.038-35.174,47.575-21,17.665,10.194,33.1,30.071,41.4,51.2,4.143,10.522,6.511,21.342,6.511,31.439v4.316L510.7,581.963v-7.821c0-9.867,2.258-17.814,6.235-23.52,8.223-11.878,23.814-14.108,41.674-3.793,26.463,15.274,47.909,52.27,47.909,82.641l.873,3.528s22.13,10.39,35.129,9.878c1.6-.063-2.517,2.793-5.741,2.81-14.263.075-36.071-9.137-36.071-9.137l-1.218-.655V625.406c0-25.905-18.3-57.471-40.881-70.51-18.228-10.522-33.657-5.752-38.933,10.108a41.733,41.733,0,0,0-1.942,13.2v13.93l-3.437-1.845Z",
    transform: "translate(-171.87 -288.523)",
    fill: "#9099af"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_533",
    "data-name": "Path 533",
    d: "M256.03,396.148c59.758,37.571,238.952,152.128,238.952,152.128s68.292,42.656,79.233,54.58,30.037,42.932,32.675,47.633S628.1,660.654,628.1,660.654s-6.155-24.13-8.792-31.9c-11.43-26.974-99.938-82.313-110.488-90.421-5.982-7.292-36.209-65.137-62.982-89.985-4.528-4.206-20.578-20.63-59.086-44.271s-75.957-40.829-85.8-43.892-68.648,6.787-80.428,5.028-18.107-2.994-18.107-2.994-21.509-15-25.463-15.969c-1.483,1.575-2.281,2.528-2.362,2.62l-.006.006S209.8,367.082,256.03,396.148Z",
    transform: "translate(-163.374 -346.165)",
    fill: "#efeef0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_124",
    "data-name": "Group 124",
    transform: "translate(47.702 92.259)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_123",
    "data-name": "Group 123"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_534",
    "data-name": "Path 534",
    d: "M252.4,428.826c0,22.653-16,31.778-35.732,20.377s-35.738-38.99-35.738-61.637,16-31.767,35.738-20.371S252.4,406.185,252.4,428.826Z",
    transform: "translate(-180.935 -362.286)",
    fill: "#2d2c37"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_122",
    "data-name": "Group 122"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_535",
    "data-name": "Path 535",
    d: "M252.4,428.826c0,22.653-16,31.778-35.732,20.377s-35.738-38.99-35.738-61.637,16-31.767,35.738-20.371S252.4,406.185,252.4,428.826Z",
    transform: "translate(-180.935 -362.286)",
    fill: "#393843"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_536",
    "data-name": "Path 536",
    d: "M249.771,426.669c0,21.785-15.389,30.56-34.376,19.6s-34.376-37.507-34.376-59.292,15.389-30.566,34.376-19.6S249.771,404.884,249.771,426.669Z",
    transform: "translate(-180.531 -360.537)",
    fill: "#2d2c37"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_537",
    "data-name": "Path 537",
    d: "M240.5,418.347c0,18.555-13.108,26.032-29.273,16.7s-29.278-31.945-29.278-50.5,13.108-26.02,29.278-16.688S240.5,399.8,240.5,418.347Z",
    transform: "translate(-176.113 -354.916)",
    fill: "#504f58"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_121",
    "data-name": "Group 121",
    transform: "translate(7.982 9.838)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_538",
    "data-name": "Path 538",
    d: "M237.812,415.661c0,17.584-12.418,24.664-27.744,15.82s-27.744-30.267-27.744-47.857,12.424-24.664,27.744-15.814S237.812,398.082,237.812,415.661Z",
    transform: "translate(-182.324 -363.998)",
    fill: "#bababe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_539",
    "data-name": "Path 539",
    d: "M182.888,387.08c1.161,10.091,6.223,21.613,14.2,30.778,7.982,9.143,17,13.751,24.25,13.3a12.522,12.522,0,0,0,8.292-3.66,11.141,11.141,0,0,0,1.965-2.471c.121-.19.241-.356.339-.546a13.882,13.882,0,0,0,1.046-2.161,22.071,22.071,0,0,0,.994-3.161,28.386,28.386,0,0,0,.667-6.344c0-1.017-.052-2.063-.144-3.109-.029-.54-.1-1.063-.167-1.592l-.144-1.063c-.046-.333-.092-.672-.167-1-.167-.994-.356-2.023-.615-3.046-.121-.488-.241-.971-.385-1.465a9.576,9.576,0,0,0-.356-1.235c-.161-.6-.356-1.213-.569-1.81-.144-.448-.287-.9-.448-1.328a57.664,57.664,0,0,0-2.425-5.724c-.19-.408-.379-.781-.569-1.161-.667-1.287-1.356-2.546-2.115-3.8-.19-.3-.379-.615-.569-.925-.356-.569-.736-1.138-1.092-1.69a62.151,62.151,0,0,0-4.678-6.149c-.856-.971-1.712-1.9-2.592-2.753-.4-.431-.833-.833-1.235-1.212-.121-.121-.259-.236-.379-.356-.333-.31-.684-.615-1.023-.9a34.687,34.687,0,0,0-12.349-7.223c-7.028-2.109-13.32-.471-16.935,5.275-.115.167-.236.356-.333.523a18.3,18.3,0,0,0-1.638,3.8A30,30,0,0,0,182.888,387.08Z",
    transform: "translate(-180.894 -362.138)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_540",
    "data-name": "Path 540",
    d: "M214.655,378.644l.259,7.792c2.925-.236,5.821-.523,8.528-.879-.356-.569-.736-1.138-1.092-1.69a62.146,62.146,0,0,0-4.678-6.149c-.856-.971-1.712-1.9-2.592-2.753-.4-.431-.833-.833-1.236-1.212-.121-.121-.259-.236-.379-.356-.333-.31-.684-.615-1.023-.9a34.688,34.688,0,0,0-12.349-7.223c-7.028-2.109-13.32-.471-16.935,5.275C203.323,363.634,214.655,378.644,214.655,378.644Z",
    transform: "translate(-178.365 -362.138)",
    fill: "#393843"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_541",
    "data-name": "Path 541",
    d: "M182.96,368.743s6.723,8.913,13.631,11.263,20.285,18.527,20.285,18.527l-1.023-30.307C200.056,369.416,182.96,368.743,182.96,368.743Z",
    transform: "translate(-179.305 -343.928)",
    fill: "#393843"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_542",
    "data-name": "Path 542",
    d: "M185.553,381c.994,8.671,5.344,18.578,12.206,26.439a37.129,37.129,0,0,0,11.78,9.355v.029a18.67,18.67,0,0,0,9.028,2.04,3.012,3.012,0,0,0,.638-.075,8.494,8.494,0,0,0,1.925-.356,28.389,28.389,0,0,0,.667-6.344c0-1.017-.052-2.063-.144-3.109-.029-.54-.1-1.063-.167-1.592l-.144-1.063c-.046-.333-.092-.672-.167-1-.167-.994-.356-2.023-.615-3.046-.121-.488-.241-.971-.385-1.465a9.575,9.575,0,0,0-.356-1.235c-.161-.6-.356-1.213-.569-1.81-.144-.448-.287-.9-.448-1.328a57.653,57.653,0,0,0-2.425-5.724c-.19-.408-.379-.781-.569-1.161-.667-1.287-1.356-2.546-2.115-3.8-.523-.879-1.092-1.753-1.661-2.615a62.136,62.136,0,0,0-4.678-6.149c-.856-.971-1.712-1.9-2.592-2.753-.4-.431-.833-.833-1.235-1.212-.121-.121-.259-.236-.379-.356-.333-.31-.684-.615-1.023-.9a34.687,34.687,0,0,0-12.349-7.223,12.754,12.754,0,0,0-2.115,2.736,15.362,15.362,0,0,0-1.4,3.252,23.5,23.5,0,0,0-.908,5.511A31.7,31.7,0,0,0,185.553,381Z",
    transform: "translate(-168.049 -361.41)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_543",
    "data-name": "Path 543",
    d: "M192.227,388.851l-.649,6.08v.023l.649-6.1,4.741-2.753,3.442-7.057c-.523-.879-1.092-1.753-1.661-2.615a62.144,62.144,0,0,0-4.678-6.149c-.856-.971-1.713-1.9-2.592-2.753-.4-.431-.833-.833-1.236-1.213-.121-.121-.259-.236-.379-.356-.925.546-1.684,1.023-1.735,1.069l5.936,6.821Z",
    transform: "translate(-154.766 -354.698)",
    fill: "url(#linear-gradient-3)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_544",
    "data-name": "Path 544",
    d: "M189.379,372.215l-.649,6.08v.023l4.678,15.131,2.092,6.815c.712,1.5-1.4,4.9-.431,4.706,1.569-.31,5.465-2.615,7.551-4.017.121-.19.241-.356.339-.546a13.887,13.887,0,0,0,1.046-2.16,3.582,3.582,0,0,0-.362-1.092l-.569-1.713-8.551-25.17-.4-.81Z",
    transform: "translate(-151.918 -338.061)",
    fill: "url(#linear-gradient-4)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_545",
    "data-name": "Path 545",
    d: "M187.948,366.108a1.6,1.6,0,0,1,1.523.172l22.7,9.614.638.368.023,12.183-5.04-2.9-18.814-7.379a4.927,4.927,0,0,1-2.207-3.672c-.121-2.66-4.224-3.247-3.718-5.545C183.144,368.516,187.643,366.269,187.948,366.108Z",
    transform: "translate(-179.075 -354.573)",
    fill: "url(#linear-gradient-5)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_120",
    "data-name": "Group 120",
    transform: "translate(2.906 12.059)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_546",
    "data-name": "Path 546",
    d: "M195.87,397.833l9.867-20.274c.483-.839.184-2.379-.718-3.6-.931-1.27-1.925-2.511-2.965-3.707s-2.1-2.3-3.172-3.339c-1.034-.988-2.166-1.086-2.649-.247l-9.861,20.28Z",
    transform: "translate(-166.021 -366.096)",
    fill: "#dfdfe3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_547",
    "data-name": "Path 547",
    d: "M208.926,388.92l-.017-12.188-.638-.362-22.7-9.608c-1.029-.592-1.919-.293-2.143.73a28.388,28.388,0,0,0-.557,7.482,4.91,4.91,0,0,0,2.2,3.672l18.814,7.373Z",
    transform: "translate(-182.83 -364.367)",
    fill: "#dfdfe3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_548",
    "data-name": "Path 548",
    d: "M205.277,400.731c.661-.523.684-1.816.063-3.109l-9.125-26.877-.385-.8-8.459,2.459,3.046,6.373,6.787,21.969c.7,1.483,2.017,2.477,2.994,2.281A11.807,11.807,0,0,0,205.277,400.731Z",
    transform: "translate(-161.275 -347.847)",
    fill: "#dfdfe3"
  })))))), /*#__PURE__*/React.createElement("path", {
    id: "Path_550",
    "data-name": "Path 550",
    d: "M305.184,459.3c0,22.647-16,31.767-35.737,20.377s-35.732-38.99-35.732-61.643,16-31.767,35.732-20.377S305.184,436.657,305.184,459.3Z",
    transform: "translate(117.288 -125.392)",
    fill: "#3e3e3e"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_129",
    "data-name": "Group 129",
    transform: "translate(351.003 267.367)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_128",
    "data-name": "Group 128"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_551",
    "data-name": "Path 551",
    d: "M305.184,459.3c0,22.647-16,31.767-35.737,20.377s-35.732-38.99-35.732-61.643,16-31.767,35.732-20.371S305.184,436.662,305.184,459.3Z",
    transform: "translate(-233.715 -392.758)",
    fill: "#2d2c37"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_127",
    "data-name": "Group 127"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_552",
    "data-name": "Path 552",
    d: "M305.184,459.3c0,22.647-16,31.767-35.737,20.377s-35.732-38.99-35.732-61.643,16-31.767,35.732-20.371S305.184,436.662,305.184,459.3Z",
    transform: "translate(-233.715 -392.758)",
    fill: "#393843"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_553",
    "data-name": "Path 553",
    d: "M302.551,457.145c0,21.785-15.389,30.554-34.376,19.6S233.8,439.234,233.8,417.449s15.389-30.56,34.376-19.6S302.551,435.361,302.551,457.145Z",
    transform: "translate(-233.311 -391.009)",
    fill: "#2d2c37"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_554",
    "data-name": "Path 554",
    d: "M293.277,448.822c0,18.55-13.1,26.026-29.273,16.688s-29.273-31.939-29.273-50.489S247.839,389,264,398.333,293.277,430.267,293.277,448.822Z",
    transform: "translate(-228.893 -385.386)",
    fill: "#504f58"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_126",
    "data-name": "Group 126",
    transform: "translate(7.982 9.839)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_555",
    "data-name": "Path 555",
    d: "M290.592,446.136c0,17.584-12.418,24.664-27.744,15.82S235.1,431.678,235.1,414.1s12.424-24.664,27.744-15.82S290.592,428.552,290.592,446.136Z",
    transform: "translate(-235.104 -394.47)",
    fill: "#bababe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_556",
    "data-name": "Path 556",
    d: "M235.664,417.55c1.167,10.091,6.224,21.613,14.205,30.778,7.976,9.148,17,13.757,24.25,13.3a12.544,12.544,0,0,0,8.286-3.655,11.367,11.367,0,0,0,1.971-2.477,4.485,4.485,0,0,0,.333-.546,14.42,14.42,0,0,0,1.046-2.161,21.778,21.778,0,0,0,1-3.155,28.723,28.723,0,0,0,.661-6.344c0-1.023-.046-2.063-.138-3.109-.029-.552-.1-1.069-.172-1.592l-.138-1.069c-.052-.333-.1-.667-.167-1-.167-.994-.356-2.017-.621-3.04-.115-.5-.236-.971-.379-1.471a10.128,10.128,0,0,0-.356-1.235c-.167-.592-.356-1.213-.569-1.8-.144-.448-.287-.9-.454-1.333A56.989,56.989,0,0,0,282,421.917c-.19-.4-.379-.782-.569-1.161-.667-1.281-1.356-2.54-2.115-3.8-.19-.31-.385-.615-.569-.925-.356-.569-.741-1.138-1.092-1.684a61.287,61.287,0,0,0-4.683-6.149c-.856-.977-1.712-1.9-2.586-2.758-.408-.425-.833-.827-1.236-1.212-.121-.115-.264-.235-.379-.351-.333-.316-.69-.626-1.023-.9a34.733,34.733,0,0,0-12.349-7.223c-7.028-2.115-13.326-.477-16.935,5.275a4.228,4.228,0,0,0-.333.523,17.875,17.875,0,0,0-1.638,3.8A30.076,30.076,0,0,0,235.664,417.55Z",
    transform: "translate(-233.676 -392.611)",
    fill: "url(#linear-gradient-6)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_557",
    "data-name": "Path 557",
    d: "M267.429,409.12l.264,7.787c2.919-.236,5.815-.517,8.528-.879-.356-.569-.741-1.138-1.092-1.684a61.287,61.287,0,0,0-4.684-6.149c-.856-.977-1.712-1.9-2.586-2.758-.408-.425-.833-.827-1.235-1.212-.121-.115-.265-.235-.379-.351-.333-.316-.69-.626-1.023-.9a34.733,34.733,0,0,0-12.349-7.223c-7.028-2.115-13.326-.477-16.935,5.275C256.1,394.11,267.429,409.12,267.429,409.12Z",
    transform: "translate(-231.145 -392.611)",
    fill: "#393843"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_558",
    "data-name": "Path 558",
    d: "M235.74,399.221s6.718,8.907,13.631,11.257,20.285,18.527,20.285,18.527L268.633,398.7C252.836,399.888,235.74,399.221,235.74,399.221Z",
    transform: "translate(-232.085 -374.403)",
    fill: "#393843"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_559",
    "data-name": "Path 559",
    d: "M238.329,411.474c1,8.672,5.344,18.573,12.206,26.44a37.313,37.313,0,0,0,11.78,9.35v.023a18.559,18.559,0,0,0,9.028,2.046,2.733,2.733,0,0,0,.644-.075,8.615,8.615,0,0,0,1.925-.35,28.722,28.722,0,0,0,.661-6.344c0-1.023-.046-2.063-.138-3.109-.029-.552-.1-1.069-.172-1.592l-.138-1.069c-.052-.333-.1-.667-.167-1-.167-.994-.356-2.017-.621-3.04-.115-.5-.236-.971-.379-1.471a10.132,10.132,0,0,0-.356-1.235c-.167-.592-.356-1.212-.569-1.8-.144-.448-.287-.9-.454-1.333a56.992,56.992,0,0,0-2.419-5.724c-.19-.4-.379-.782-.569-1.161-.667-1.282-1.356-2.54-2.115-3.8-.523-.873-1.1-1.758-1.661-2.609a61.28,61.28,0,0,0-4.684-6.149c-.856-.977-1.712-1.9-2.586-2.758-.408-.425-.833-.827-1.236-1.213-.121-.115-.264-.235-.379-.351-.333-.316-.69-.626-1.023-.9a34.733,34.733,0,0,0-12.349-7.223,12.228,12.228,0,0,0-2.115,2.73,15.447,15.447,0,0,0-1.4,3.258,23.462,23.462,0,0,0-.9,5.505A31.742,31.742,0,0,0,238.329,411.474Z",
    transform: "translate(-220.831 -391.879)",
    fill: "url(#linear-gradient-7)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_560",
    "data-name": "Path 560",
    d: "M245,419.313l-.649,6.091v.023l.649-6.114,4.741-2.747,3.448-7.057c-.523-.874-1.1-1.758-1.661-2.609a61.269,61.269,0,0,0-4.684-6.149c-.856-.977-1.712-1.9-2.586-2.759-.408-.425-.833-.827-1.236-1.212-.121-.115-.264-.235-.379-.351-.925.546-1.69,1.017-1.735,1.063l5.93,6.827Z",
    transform: "translate(-207.546 -385.168)",
    fill: "url(#linear-gradient-8)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_561",
    "data-name": "Path 561",
    d: "M242.158,402.681l-.649,6.091v.023l4.678,15.125,2.1,6.821c.707,1.494-1.408,4.9-.431,4.7,1.569-.3,5.459-2.615,7.551-4.017a4.5,4.5,0,0,0,.333-.546,14.421,14.421,0,0,0,1.046-2.161,3.414,3.414,0,0,0-.356-1.092l-.569-1.713L247.3,400.739l-.4-.8Z",
    transform: "translate(-204.703 -368.536)",
    fill: "url(#linear-gradient-9)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_562",
    "data-name": "Path 562",
    d: "M240.727,396.584a1.575,1.575,0,0,1,1.528.172l22.7,9.608.638.362.017,12.188-5.04-2.9-18.814-7.373a4.909,4.909,0,0,1-2.2-3.666c-.126-2.666-4.229-3.247-3.724-5.545C235.928,398.992,240.428,396.74,240.727,396.584Z",
    transform: "translate(-231.86 -385.046)",
    fill: "url(#linear-gradient-10)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_125",
    "data-name": "Group 125",
    transform: "translate(2.906 12.06)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_563",
    "data-name": "Path 563",
    d: "M248.655,428.3l9.861-20.268c.483-.845.19-2.379-.713-3.609q-1.405-1.905-2.965-3.7c-1.046-1.2-2.1-2.3-3.178-3.339-1.034-.994-2.161-1.086-2.643-.247l-9.867,20.268Z",
    transform: "translate(-218.805 -396.569)",
    fill: "#dfdfe3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_564",
    "data-name": "Path 564",
    d: "M261.706,419.4l-.023-12.188-.632-.368-22.7-9.614c-1.023-.586-1.919-.282-2.143.73a28.474,28.474,0,0,0-.552,7.488,4.888,4.888,0,0,0,2.2,3.678l18.814,7.373Z",
    transform: "translate(-235.61 -394.843)",
    fill: "#dfdfe3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_565",
    "data-name": "Path 565",
    d: "M258.057,431.208c.661-.517.684-1.816.063-3.1l-9.126-26.882-.391-.81-8.453,2.471,3.046,6.367,6.781,21.969c.707,1.482,2.023,2.477,3,2.287A11.918,11.918,0,0,0,258.057,431.208Z",
    transform: "translate(-214.054 -378.327)",
    fill: "#dfdfe3"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_130",
    "data-name": "Group 130",
    transform: "translate(92.134 47.368)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_567",
    "data-name": "Path 567",
    d: "M425.854,591.42l-.741-.442C423.4,589.949,253.815,488.7,243.6,481.8c-2.707-1.827-11.039-16.423-11.757-21.406-7.545-51.776-40.565-76.107-40.9-76.342l-.138-.1-2.138-11.619.011-.069L190.569,358l3.994-3.523,13.234,4.563L410.959,486.609,428.6,500.717l-3.661,6.361-2.546,10c-.011.126-2.138,18.038-1.735,26.836.632,13.734,5.04,46.311,5.086,46.645ZM191.569,383.477c2.356,1.776,33.749,26.376,41.093,76.8.69,4.741,8.884,19.124,11.407,20.826,9.85,6.654,168.413,101.357,180.728,108.707-.707-5.269-4.4-33.341-4.976-45.857-.408-8.867,1.724-26.848,1.747-27.026l2.615-10.211,3.333-5.792-17.038-13.637-203.041-127.5-12.688-4.362-3.385,2.994-1.845,13.9Z",
    transform: "translate(-188.667 -354.474)",
    fill: "#9099af"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_568",
    "data-name": "Path 568",
    d: "M176.511,347.771l2.649,6.827,6.9,7.3,10.918,10.614-7.666,5.459-5.649-3.54a18.252,18.252,0,0,1-7.442-9.149l-1.4-3.775-1.207-9.545Z",
    transform: "translate(-167.949 -338.922)",
    fill: "#dee0df"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_569",
    "data-name": "Path 569",
    d: "M206.343,397.049s-26.957-26.641-28.893-28.56-4.655-5.114-4.655-5.114v-6.407l4.178,12.039,12.665,10.332,2.81,4.649Z",
    transform: "translate(-171.87 -295.273)",
    fill: "#d2d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_570",
    "data-name": "Path 570",
    d: "M280.432,417.745s-13.257-.414-20.992-5.683a30.359,30.359,0,0,1-10.608-12.872l26.854,10.166Z",
    transform: "translate(189.041 -94.866)",
    fill: "#efeef0"
  }))), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Path_571",
    "data-name": "Path 571",
    d: "M260.764,507.643l168.462-97.258-8.788-31.9L251.976,475.74Z",
    transform: "translate(203.961 -94.357)",
    fill: "#efeef0"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "Path_572",
    "data-name": "Path 572",
    d: "M255.267,499.255,423.726,402l2.986-4.13v-5.449l-4.745-8.384L253.5,481.292l4.748,8.39v5.449Z",
    transform: "translate(208.935 -70.291)",
    fill: "#efeef0"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "Path_573",
    "data-name": "Path 573",
    d: "M233.708,454.594s11.286,10.206,23.618,8.436,42.662-14.108,83.733-36.542,61.976-45.047,64.275-50.9-5.626-12.027-5.626-12.027Z",
    transform: "translate(117.254 -165.192)",
    fill: "#292929"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "Path_574",
    "data-name": "Path 574",
    d: "M371.607,348.645c-15.619,13.309-36.375,26.635-53.379,36.858-12.464,7.471-24.388,14.177-35.306,20.032-35.4,18.987-60.471,29.215-60.471,29.215l.057.075c.925.845,12.516,11.769,36.554,46.5,15.383,22.216,23.842,36.4,28.089,44.064v-.006s3.413,4.885,9.919,2.471c.184-.069.368-.132.552-.213,1.707-.724,2.994-1.276,3.965-1.689.316-.115.638-.253.954-.4a3.755,3.755,0,0,0,.5-.218c1.023-.431,1.3-.552,1.391-.586l.034-.017c21.653-9.384,46.219-21.773,65.821-32.29,10.936-5.85,20.32-11.12,26.807-14.952,19.3-11.424,45.122-28.916,53.965-40.053a21.275,21.275,0,0,0,2.092-3.092A952.832,952.832,0,0,0,371.607,348.645Z",
    transform: "translate(63.818 -235.977)",
    fill: "#37464e"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "Path_575",
    "data-name": "Path 575",
    d: "M234.321,377.72c3.488,6.275,12.188,4.442,14.705,2.856,2.58-1.62,24.038-13.734,27.279-16.217,2.776-2.121-.1-8.838-.994-10.74-4.62,2.925-9.143,5.695-13.43,8.275C252.3,367.641,243.05,372.922,234.321,377.72Z",
    transform: "translate(120.164 -212.368)",
    fill: "#131313"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "Path_576",
    "data-name": "Path 576",
    d: "M349.995,433.812l-4.753.236s-47.472-30.353-101.69-64.941a310.531,310.531,0,0,0,27.474-20.4c4.8,4.649,10.085,10.016,15.872,16.234C314.59,394.713,349.995,433.812,349.995,433.812Z",
    transform: "translate(163.979 -235.687)",
    fill: "#566770"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "Path_577",
    "data-name": "Path 577",
    d: "M403.9,369.359c-8.844,11.137-34.663,28.629-53.965,40.053-6.488,3.833-15.872,9.1-26.808,14.952-19.6,10.516-44.168,22.906-65.821,32.29l-.034.017c-.086.035-.368.155-1.391.586a3.736,3.736,0,0,1-.5.218c-.316.149-.638.288-.954.4-.971.414-2.258.965-3.965,1.69-.184.08-.368.143-.552.212-6.505,2.414-9.919-2.471-9.919-2.471l-.85,2.741q-3.336-6.172-6.758-12.091c1.207-1.172,3.528-3.563,6.608-7.057,4.58-5.184,61.993-31.721,63.516-32.577.92-.523,1.839-1.04,2.741-1.552,52.747-29.911,63.079-40.628,69.636-43.151a8.579,8.579,0,0,1,3.275-.638c7.643,0,14.453-.029,23.549,3.212Z",
    transform: "translate(110.975 -167.907)",
    fill: "#63747d"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    id: "Path_578",
    "data-name": "Path 578",
    d: "M248.256,412.822l-3.505-1.7s-.109-17.492,1.753-19.785,54.4-29.71,56.339-29.451,25.578,13.906,25.578,13.906Z",
    transform: "translate(169.664 -173.139)",
    fill: "#63747d"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    id: "Path_579",
    "data-name": "Path 579",
    d: "M259.058,363.524l-8.281,4.781a145.548,145.548,0,0,0-13.682,8.97h0a5.3,5.3,0,0,0-1.879,5.091l1.029,4.821c.391,1.822,1.85,2.707,3.4,2.04h0a128.479,128.479,0,0,0,14.091-7.057l8.286-4.781a145.1,145.1,0,0,0,13.677-8.976h0a5.286,5.286,0,0,0,1.879-5.086l-1.029-4.821c-.385-1.827-1.85-2.707-3.4-2.046h0A130.035,130.035,0,0,0,259.058,363.524Z",
    transform: "translate(123.947 -199.913)",
    fill: "#63747d"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    id: "Path_580",
    "data-name": "Path 580",
    d: "M246.906,365.931c-.092-2.368-.6-8.9-.6-8.9l-8.24.178s.919,9.258,1.017,9.6c.466,1.506,2.477,3.172,3.344,3.086C244.446,369.684,247.009,368.488,246.906,365.931Z",
    transform: "translate(137.921 -196.177)",
    fill: "#63747d"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    id: "Path_581",
    "data-name": "Path 581",
    d: "M245.613,358.111a3.463,3.463,0,0,1-1.149,5.126,4.443,4.443,0,0,1-5.712-1.143,3.469,3.469,0,0,1,1.149-5.132A4.445,4.445,0,0,1,245.613,358.111Z",
    transform: "translate(137.921 -199.246)",
    fill: "#63747d"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    id: "Path_582",
    "data-name": "Path 582",
    d: "M429.107,385.455c1.477,5.356-33.847,33.416-44.914,41.691-9.43,7.057-21.871,14.579-39.117,24.659-19.09,11.165-34.169,17.619-84.433,30.9-3.471.92-10.493-9.815-10.493-9.815l151.662-95.881Z",
    transform: "translate(195.292 -101.328)",
    fill: "#efeef0"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    id: "Path_583",
    "data-name": "Path 583",
    d: "M283.906,402.208c-15.809,1.557-24.75-4.178-28.6-8.223s-6.028,4.247-6.028,4.247,10.039,17.239,18.331,17.239S283.906,402.208,283.906,402.208Z",
    transform: "translate(191.153 -26.028)",
    fill: "#efeef0"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    id: "Path_584",
    "data-name": "Path 584",
    d: "M227.542,363.631s11.533,10.321,36.617,46.558,31.773,51.144,31.773,51.144l-9.206.661-33.853-56.408-31.5-39.766Z",
    transform: "translate(58.72 -164.845)",
    fill: "#efeef0"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    id: "Path_585",
    "data-name": "Path 585",
    d: "M407.484,340.2c-41.559,17.308-48.248,20.021-74.808,35.485-26.537,15.47-56.707,33.652-70.073,48.167,0,0-8.074-.558-19.8-.684-16.441-.2-40.07.431-58.666,4.58,0,0,6.821-8.126,20.4-19.015s27.175-21.124,56.023-38.887,65.723-31.87,74.475-35.387a35.905,35.905,0,0,1,7.091-2.052,21.7,21.7,0,0,1,7.522-.218S394.491,335.221,407.484,340.2Z",
    transform: "translate(-118.021 -315.083)",
    fill: "#37464e"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    id: "Path_586",
    "data-name": "Path 586",
    d: "M174.8,428.415c3.184-5.873,6.287-12.3,12.763-17.038s18.676-15.884,57.35-39.927,72.119-39.766,81.112-41.731,18.383.937,18.383.937l-14.619,29.089Z",
    transform: "translate(-162.363 -329.039)",
    fill: "#efeef0"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_587",
    "data-name": "Path 587",
    d: "M370.285,445.444c-19.6,10.516-44.168,22.906-65.821,32.29l-.034.017c-.086.035-.368.155-1.391.586a3.747,3.747,0,0,1-.5.218c-.316.149-.638.287-.954.4-.971.414-2.258.965-3.965,1.69-.184.081-.368.143-.552.212-6.505,2.414-9.919-2.471-9.919-2.471l-.85,2.741a554.921,554.921,0,0,0-63.85-93.37s25.072-10.229,60.471-29.215c5.333,3.867,26.957,20.251,58.166,53.85C354.034,426.325,363.481,437.209,370.285,445.444Z",
    transform: "translate(63.818 -188.986)",
    fill: "#1c2121",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    id: "Path_588",
    "data-name": "Path 588",
    d: "M427.785,400.122a9.277,9.277,0,0,1,0,1.873,3.613,3.613,0,0,1-.161.81c.2,10.533-12.637,22.618-27.244,32.376-.034-1.517-.034-2.391-.063-2.9v-.713c.873-1.23-2.718-6.66-3.557-6.4-.839.224-24.658,15.935-43.145,26.762-18.481,10.792-41.978,22.618-45.593,24.589-1.684.908-3.718.937-5.43,4.425-1.712,3.431-3.069,6.919-3.454,7.884-.069.167-.1.258-.1.258a10.548,10.548,0,0,1-1.1,3.235,95.567,95.567,0,0,1-11.344,4.557c-23.135,7.016-32.8,5.562-32.8,5.562l4.27-2.879h.029L423.55,388.583s3.488,6.114,4.138,10.987C427.716,399.766,427.75,399.961,427.785,400.122Z",
    transform: "translate(212.583 -46.41)",
    fill: "#d2d3d4"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    id: "Path_589",
    "data-name": "Path 589",
    d: "M291.8,403.941c-10.223,5.4-28.054,8.758-37.255,8.355-.58,9.827,0,10.5,0,10.5s4,1.322,16.119-1.626S290.322,415.388,291.8,403.941Z",
    transform: "translate(214.929 26.486)",
    fill: "#9099af"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    id: "Path_590",
    "data-name": "Path 590",
    d: "M296.736,388.62c-1.316,7.5-12.349,16.929-16.32,20.515.632,10.591.264,12.28.264,12.28,8.683-7.068,14.533-14.6,14.912-16.1C296.782,400.653,297.185,398.516,296.736,388.62Z",
    transform: "translate(338.954 -46.235)",
    fill: "#9099af"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    id: "Path_591",
    "data-name": "Path 591",
    d: "M286.593,411.136a107.064,107.064,0,0,0,12.545-5.108c-.069.167-.1.258-.1.258a10.549,10.549,0,0,1-1.1,3.235,95.577,95.577,0,0,1-11.344,4.557c-23.135,7.016-32.8,5.562-32.8,5.562l4.27-2.879h.029C262.94,416.566,272.146,415.5,286.593,411.136Z",
    transform: "translate(212.583 36.388)",
    fill: "#9099af"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    id: "Path_592",
    "data-name": "Path 592",
    d: "M306.758,391.123a9.272,9.272,0,0,1,0,1.873,3.612,3.612,0,0,1-.161.81c.2,10.533-12.637,22.618-27.244,32.376-.034-1.517-.034-2.39-.063-2.9,14.636-9.763,27.5-21.883,27.307-32.416.029-.1.029-.2.063-.293a.123.123,0,0,0,.029-.092A4.478,4.478,0,0,1,306.758,391.123Z",
    transform: "translate(333.61 -37.411)",
    fill: "#9099af"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    id: "Path_593",
    "data-name": "Path 593",
    d: "M253.811,510.572s24.888-4.322,42.587-11.706,16.47-6.712,44.329-21.894,82.951-47.374,84.531-67.786c1.442-17.487-9.148-27.537-9.148-27.537l2.143,17.556-1.448,8.677L316.6,470.72,256.173,501Z",
    transform: "translate(212.674 -79.323)",
    fill: "#e7e7e9"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    id: "Path_594",
    "data-name": "Path 594",
    d: "M254.222,499.589s24.882-4.322,42.581-11.706,16.475-6.718,44.334-21.9,80.009-45.633,81.589-66.045c.167-9.252-7.04-17.992-7.04-17.992l-3.017,25.894L390.61,421.534l-88.083,51.989L261.974,491.2Z",
    transform: "translate(214.624 -77.913)",
    fill: "#efeef0"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    id: "Path_595",
    "data-name": "Path 595",
    d: "M348.866,455.025s-19.642-16.682-41.381-31.893-66.211-41.817-66.211-41.817l2.724-1.3s39.783,24.29,60.516,37.346,42.329,31.313,42.329,31.313S349.217,452.732,348.866,455.025Z",
    transform: "translate(153.167 -87.102)",
    fill: "#e7e7e9"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    id: "Path_596",
    "data-name": "Path 596",
    d: "M344.315,452.328s-77.066-78.859-82.778-83.457c2.23.138,73.791,70.958,76.578,74.279A83.258,83.258,0,0,1,344.315,452.328Z",
    transform: "translate(249.345 -139.974)",
    fill: "#e7e7e9"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    id: "Path_597",
    "data-name": "Path 597",
    d: "M226.084,422.935c10.574-8.4,22.118-17.423,31.376-23.653,49.374-33.209,100.524-55.046,100.524-55.046l-15.855-12.183a35.909,35.909,0,0,0-7.091,2.052c-8.752,3.517-45.622,17.613-74.475,35.387s-42.438,28-56.023,38.887-20.4,19.015-20.4,19.015c.718-.161,1.391-.3,2.046-.431C198.661,424.4,213.12,423.309,226.084,422.935Z",
    transform: "translate(-118.021 -314.726)",
    fill: "#63747d"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_132",
    "data-name": "Group 132",
    transform: "translate(193.887 209.29)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_598",
    "data-name": "Path 598",
    d: "M208.006,459.018,206.374,454l.034-.115,3.672-13.711c-.057-1.333-.908-22.664-.908-29.106,0-6.643,2.431-25.957,2.454-26.152l4.6-19.458.81.19-4.586,19.417c-.017.155-2.436,19.418-2.436,26s.9,28.911.9,29.135l.006.063-.017.057-3.655,13.654,1.552,4.781Z",
    transform: "translate(-206.374 -365.459)",
    fill: "#9099af"
  }))), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    id: "Path_599",
    "data-name": "Path 599",
    d: "M436.039,526.306l-13.527-1.649S249.047,413.744,189.289,376.173c0,0,36.157-24.532,38.789-25.733s12.309-.012,40.134,13.476,63.3,35.939,69.625,40.2,29.572,19.935,49.431,44.53C405.95,471.789,436.039,526.306,436.039,526.306Z",
    transform: "translate(-93.581 -229.158)",
    fill: "#292929"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    id: "Path_600",
    "data-name": "Path 600",
    d: "M416.677,515.678c-13.527-8.648-164.109-104.908-225.792-143.795,12.717-8.591,28.577-19.216,31.525-20.923.08,0,.178-.006.3-.006,2.471,0,10.907,1.3,35.732,13.338,26.693,12.941,61.534,34.812,69.01,39.846,19.165,12.889,35.421,27.537,48.328,43.518,13.774,17.061,34.209,52.1,43.444,68.332Z",
    transform: "translate(-86.005 -225.017)",
    fill: "#37464e"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    id: "Path_601",
    "data-name": "Path 601",
    d: "M221.869,356.555s-14.935,30.635-14.935,50.914l18.395,11.913s-1.253-40.973,6.689-56.023A86.394,86.394,0,0,0,221.869,356.555Z",
    transform: "translate(-9.829 -198.432)",
    fill: "#292929"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    id: "Path_602",
    "data-name": "Path 602",
    d: "M241.945,387.079s3.109-.454,4.385-1.506.328-4.908-1.856-6.292-8.309,1.684-9.321,1.167-7.229,2.1-7.229,2.1l2.017,4.442Z",
    transform: "translate(89.796 -92.281)",
    fill: "#eeeef0"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    id: "Path_603",
    "data-name": "Path 603",
    d: "M247.551,377.91c5.769-1.442,11.648.442,12.424,6.988.942,7.948-2.551,9.212-4.661,10.206a49.942,49.942,0,0,1-19.963,4.546c-9.987.115-11.206-5.224-11.206-8.769,0-.512.012-.477.04-.948.282-5.063,2.109-6.568,5.505-7.58C237.029,380.162,247.551,377.91,247.551,377.91Z",
    transform: "translate(71.864 -99.236)",
    fill: "#eeeef0"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    id: "Path_604",
    "data-name": "Path 604",
    d: "M254.213,378.41c-3.31-1.034-10.171.3-16.912,1.764s-11.8,1.35-12.338,7.9,1.592,8.137,4.39,8.568,8.108.391,16.107-1.937,9.12-3.632,10.367-5.838S257.511,379.433,254.213,378.41Z",
    transform: "translate(75.361 -96.433)",
    fill: "#efeef0"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    id: "Path_605",
    "data-name": "Path 605",
    d: "M250.626,394.322l28.141-13.688c1.132-.552,1.023-1.6-.247-2.356h0a5.208,5.208,0,0,0-4.362-.356L246.023,391.6c-1.138.557-1.023,1.615.247,2.356h0A5.157,5.157,0,0,0,250.626,394.322Z",
    transform: "translate(171.984 -98.575)",
    fill: "#292929"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    id: "Path_606",
    "data-name": "Path 606",
    d: "M261.6,391.007l23.032-17.142c.931-.69.747-1.8-.4-2.465h0a3.723,3.723,0,0,0-3.77.04l-23.038,17.142c-.931.7-.747,1.8.4,2.471h0A3.733,3.733,0,0,0,261.6,391.007Z",
    transform: "translate(226.996 -130.302)",
    fill: "#292929"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_135",
    "data-name": "Group 135",
    transform: "translate(207.033 229.65)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_607",
    "data-name": "Path 607",
    d: "M211.078,369.171c-1.879,2.281-2.96,6.1-2.138,8.287.9,2.373,17.418,12.441,19.073,12.849s2.879-4.161,2.643-5.568S211.078,369.171,211.078,369.171Z",
    transform: "translate(-208.662 -368.199)",
    fill: "#9099af"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_134",
    "data-name": "Group 134",
    transform: "translate(1.539)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_133",
    "data-name": "Group 133"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_608",
    "data-name": "Path 608",
    d: "M223.068,376.666l-11.263-7.16c-1.46-.937-2.7-.293-2.776,1.425l-.023.592a5.958,5.958,0,0,0,2.505,4.787L227,386.165c1.741,1.1,2.741-.776,1.609-3.023h0A16.531,16.531,0,0,0,223.068,376.666Z",
    transform: "translate(-208.582 -368.655)",
    fill: "#d2d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_609",
    "data-name": "Path 609",
    d: "M228.3,387.259a2.207,2.207,0,0,1-1.178-.4l-15.493-9.849a6.349,6.349,0,0,1-2.7-5.16l.023-.592a2.056,2.056,0,0,1,3.419-1.764l11.263,7.16a17.138,17.138,0,0,1,5.695,6.637c.73,1.454.7,2.9-.069,3.6A1.4,1.4,0,0,1,228.3,387.259Zm-17.423-17.418a.908.908,0,0,0-.448.1,1.485,1.485,0,0,0-.638,1.345l-.029.6a5.609,5.609,0,0,0,2.316,4.413l15.493,9.849c.276.178.787.431,1.132.121.391-.368.488-1.4-.121-2.6a16.242,16.242,0,0,0-5.4-6.31L211.927,370.2A2.047,2.047,0,0,0,210.881,369.841Z",
    transform: "translate(-208.929 -369.002)",
    fill: "#9099af"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_610",
    "data-name": "Path 610",
    d: "M212.134,372.262c-.04.925-.707,1.27-1.488.77a3.2,3.2,0,0,1-1.35-2.574c.04-.919.707-1.27,1.494-.77A3.221,3.221,0,0,1,212.134,372.262Z",
    transform: "translate(-207.2 -366.831)",
    fill: "#292929"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Group_138",
    "data-name": "Group 138",
    transform: "translate(101.843 163.084)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_611",
    "data-name": "Path 611",
    d: "M192.773,357.588c-1.879,2.276-2.959,6.1-2.138,8.281.908,2.379,17.418,12.441,19.073,12.849s2.879-4.161,2.638-5.568S192.773,357.588,192.773,357.588Z",
    transform: "translate(-190.357 -356.612)",
    fill: "#9099af"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_137",
    "data-name": "Group 137",
    transform: "translate(1.539)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_136",
    "data-name": "Group 136"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_612",
    "data-name": "Path 612",
    d: "M204.763,365.084l-11.269-7.166c-1.454-.931-2.7-.287-2.77,1.431l-.023.592a5.958,5.958,0,0,0,2.506,4.787l15.493,9.85c1.741,1.109,2.747-.776,1.609-3.023h0A16.554,16.554,0,0,0,204.763,365.084Z",
    transform: "translate(-190.278 -357.069)",
    fill: "#d2d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_613",
    "data-name": "Path 613",
    d: "M210,375.679a2.16,2.16,0,0,1-1.178-.4l-15.493-9.844a6.356,6.356,0,0,1-2.7-5.16l.029-.6a2.052,2.052,0,0,1,3.413-1.764l11.263,7.166a17.052,17.052,0,0,1,5.695,6.637c.73,1.454.7,2.9-.069,3.6A1.416,1.416,0,0,1,210,375.679Zm-17.423-17.418a.952.952,0,0,0-.448.1,1.5,1.5,0,0,0-.638,1.35l-.029.6a5.546,5.546,0,0,0,2.316,4.419l15.493,9.85c.276.178.793.425,1.126.115.4-.362.494-1.391-.115-2.6a16.232,16.232,0,0,0-5.4-6.315l-11.263-7.16A2,2,0,0,0,192.576,358.262Z",
    transform: "translate(-190.624 -357.418)",
    fill: "#9099af"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_614",
    "data-name": "Path 614",
    d: "M193.83,360.68c-.04.925-.707,1.27-1.488.77a3.2,3.2,0,0,1-1.35-2.574c.04-.925.707-1.27,1.488-.77A3.2,3.2,0,0,1,193.83,360.68Z",
    transform: "translate(-188.895 -355.245)",
    fill: "#292929"
  })))), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    id: "Path_615",
    "data-name": "Path 615",
    d: "M178.751,348.876s.781,4.459,20.015,8.752,88.5-9.137,88.5-9.137l-80.135,2.833Z",
    transform: "translate(-143.6 -236.708)",
    fill: "#efeef0"
  }))), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    id: "Path_616",
    "data-name": "Path 616",
    d: "M252.818,404.424s15.734,7.281,31.606,2.747l15.878-4.534-34.582,12.211-14.665-6.821Z",
    transform: "translate(215.892 20.297)",
    fill: "#d2d3d4"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_617",
    "data-name": "Path 617",
    d: "M355.153,384.287c-33.893,25.153-93.059,54.529-93.059,54.529S252.52,470.9,272.213,464s86.491-46.978,92.076-53.58C368.255,394.522,355.153,384.287,355.153,384.287Z",
    transform: "translate(257.249 -66.802)",
    fill: "rgba(179,179,179,0.85)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    id: "Path_618",
    "data-name": "Path 618",
    d: "M265.419,448s59.166-29.376,93.059-54.529a29.348,29.348,0,0,1,6.258,7.465c-1.58-10.355-9.585-16.653-9.585-16.653-33.893,25.153-93.059,54.529-93.059,54.529s-5.856,19.63,1.023,24.888C262.919,456.417,265.419,448,265.419,448Z",
    transform: "translate(257.251 -66.802)",
    fill: "#b3b3b3"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    id: "Path_619",
    "data-name": "Path 619",
    d: "M314.781,393.776s-24.417,9.907-38.754,9.367a49.177,49.177,0,0,1-20.774-5.861,4.41,4.41,0,0,0-6.482,3.143l-.011.161c-.207,2.023,0,8.212,0,8.212a45.6,45.6,0,0,0,18.918,9.729c13.843,3.476,29.554-.569,34.807-2.488s13.573,6.183,13.573,6.183l8.844-3.258S322.734,403.608,314.781,393.776Z",
    transform: "translate(204.562 -21.762)",
    fill: "#b3b3b3"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    id: "Path_620",
    "data-name": "Path 620",
    d: "M309.679,394.109c-1.034,10.625-7.585,15.912-14.86,22.394-1.8,3.166-1.546,14.711-1.546,14.711h0c-1.391,1.1-3.425,2.683-5.689,4.459-.776.58-1.586,1.2-2.39,1.81-2.218-12.947-8.827-26.474-8.827-26.474s8.011-6.723,18.033-16.355c10.045-9.66,11.148-13.763,11.148-13.763l-.58-2.235C305.225,379.4,307.644,386.541,309.679,394.109Z",
    transform: "translate(336.035 -93.524)",
    fill: "#b3b3b3"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    id: "Path_621",
    "data-name": "Path 621",
    d: "M174.243,356.455s1.322,3.988,14.975,13.677l13.654,9.7s-27.3-15.28-30.077-20.435Z",
    transform: "translate(-155.565 -198.906)",
    fill: "#9099af"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    id: "Path_622",
    "data-name": "Path 622",
    d: "M229.871,387.2c-1.052,5.333,9.022,17.343,11.246,13.3s2.419-9.97,0-11.045S230.343,384.814,229.871,387.2Z",
    transform: "translate(114.984 -56.79)",
    fill: "#1a1a1a"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    id: "Path_623",
    "data-name": "Path 623",
    d: "M311.585,482.179c-2.557-2.172-7.534-6.649-12.321-6.649a16.292,16.292,0,0,0-3.976.81c-3.713,1.362-8.189,2.005-17.521,2.005a45.728,45.728,0,0,1-11.091-1.264c-8.476-2.126-15.125-5.769-17.32-7.545-.057-2.316-.155-4.494-.052-5.568a1.111,1.111,0,0,1,1.155-.925,1.262,1.262,0,0,1,.609.155,52.339,52.339,0,0,0,22.17,6.235c.42.017.845.023,1.276.023,14.918,0,36.341-8.9,37.306-9.292.816-.4,58.879-29.623,92.611-54.667l-.856.287c1.707-.937,6.16-4.373,19.2-16.895a88.34,88.34,0,0,0,8.028-8.666c.563,1.862,1.161,3.913,1.735,6.022-.879,6.045-6.264,10.746-10.229,14.2-2.011,1.758-3.465,3.028-4.252,4.39-1.81,3.166-2.017,11.5-1.977,16.263l-2.712,2.132a103.015,103.015,0,0,0-3.58-11.441l-.27-.718-.557-.523c-.661-.609-1.092-.96-1.092-.96l-1.948-1.569L403.9,409.5c-30.256,22.463-78.256,47.007-88.129,51.977l-6.241,3.132,1.31,2.839a64.48,64.48,0,0,1,4.338,13.406Z",
    transform: "translate(207.372 -86.087)",
    fill: "#f0f0f0"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Group_141",
    "data-name": "Group 141",
    transform: "translate(144.032 100.744)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_624",
    "data-name": "Path 624",
    d: "M356.3,448.145l-3.27-3.35c-.052-.1-5.511-10.217-34.37-29.962-23.7-16.217-81.589-54.517-107.023-59.827-15.039-3.143-16.774-5.155-16.774-6.39,0-1.379,2.368-1.948,2.845-2.046l.172.816c-.919.2-2.178.724-2.178,1.23s1.161,2.454,16.1,5.574c25.583,5.339,83.577,43.708,107.328,59.954,28.273,19.343,34.106,29.278,34.611,30.209l3.155,3.212Z",
    transform: "translate(-194.861 -346.57)",
    fill: "#9099af"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Group_142",
    "data-name": "Group 142",
    transform: "translate(296.93 24.154)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_625",
    "data-name": "Path 625",
    d: "M377.279,424.428c-7.292-9.522-28.152-26.089-50.724-40.294-20.883-13.136-82.112-48.265-96.289-49.506-7.223-.644-8.177-.563-8.292-.546l-.121-.4-.282.322-.1-.483c.144-.339.213-.5,8.873.264,14.522,1.281,75.032,36.031,96.656,49.638,22.647,14.251,43.6,30.9,50.943,40.5Z",
    transform: "translate(-221.468 -333.242)",
    fill: "#9099af"
  })))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Group_116",
    "data-name": "Group 116",
    transform: "translate(29.832 465.236)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "home-pic"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13",
    "data-name": "Group 13",
    transform: "translate(0 14.814)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24",
    "data-name": "Path 24",
    d: "M187.043,348.687a1.189,1.189,0,0,1-.977-.979l-1-6.077-1,6.077a1.189,1.189,0,0,1-.978.979l-6.076,1,6.076,1a1.187,1.187,0,0,1,.978.978l1,6.076,1-6.076a1.187,1.187,0,0,1,.977-.978l6.077-1Z",
    transform: "translate(-111.824 -225.081)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25",
    "data-name": "Path 25",
    d: "M144.284,312.8a.944.944,0,0,1-.78-.777l-.794-4.831-.8,4.831a.942.942,0,0,1-.78.777l-4.83.8,4.83.8a.944.944,0,0,1,.78.777l.8,4.833.794-4.833a.945.945,0,0,1,.78-.777l4.833-.8Z",
    transform: "translate(-136.303 -245.793)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26",
    "data-name": "Path 26",
    d: "M197.582,289.523a1.149,1.149,0,0,1-.95-.95l-.974-5.9-.974,5.9a1.153,1.153,0,0,1-.95.95l-5.906.975,5.906.97a1.156,1.156,0,0,1,.95.953l.974,5.9.974-5.9a1.153,1.153,0,0,1,.95-.953l5.906-.97Z",
    transform: "translate(-105.317 -260.538)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27",
    "data-name": "Path 27",
    d: "M513.286,345.388a7.75,7.75,0,0,0,9.85,6.548,8.616,8.616,0,0,0,8.047-.581,7.17,7.17,0,0,0,10.587-1.978,7.765,7.765,0,0,0,9.922-1.492,7.468,7.468,0,1,0,.261-11.562,6.806,6.806,0,0,0-10.441-1.142,6.174,6.174,0,0,0-5.925-4.493,6.1,6.1,0,0,0-1.3.142,6.694,6.694,0,0,0-13.133-1.675,7.648,7.648,0,0,0-12.672,5.8c0,.154.038.3.046.452-.088,0-.17-.024-.259-.024-3.771,0-6.83,2.676-6.83,5.975s3.059,5.976,6.83,5.976a7.261,7.261,0,0,0,5.016-1.946",
    transform: "translate(13.177 -235.512)",
    fill: "#cee3f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28",
    "data-name": "Path 28",
    d: "M501.651,339.6a6.928,6.928,0,0,0,6.175,3.464,7.26,7.26,0,0,0,5.016-1.946,7.752,7.752,0,0,0,9.852,6.548,8.6,8.6,0,0,0,8.044-.583,7.169,7.169,0,0,0,10.588-1.976,7.766,7.766,0,0,0,9.924-1.494,7.414,7.414,0,0,0,12.087-4.052,7.4,7.4,0,0,0-11.509-3.241,6.806,6.806,0,0,0-10.441-1.142,6.173,6.173,0,0,0-5.925-4.493,6.1,6.1,0,0,0-1.3.142,6.694,6.694,0,0,0-13.133-1.675,7.648,7.648,0,0,0-12.672,5.8c0,.154.038.3.046.452-.088,0-.17-.024-.259-.024A6.752,6.752,0,0,0,501.651,339.6Z",
    transform: "translate(13.343 -235.512)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29",
    "data-name": "Path 29",
    d: "M570.256,363.951c.009-.183.027-.364.027-.551a9.59,9.59,0,0,0-13.081-8.944,14.5,14.5,0,0,0-28.279,3.69,13.55,13.55,0,0,0-13.9,23.221,14.072,14.072,0,0,0,26.57,6.22,11.934,11.934,0,0,0,16.893-3.661,12.581,12.581,0,1,0,11.767-19.975",
    transform: "translate(15.352 -223.411)",
    fill: "#cee3f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30",
    "data-name": "Path 30",
    d: "M577.665,368.393a12.578,12.578,0,0,0-8-4.442c.009-.183.027-.364.027-.551a9.59,9.59,0,0,0-13.081-8.944,14.5,14.5,0,0,0-28.278,3.69,13.542,13.542,0,0,0-18.307,5.635,12.939,12.939,0,0,0,4.98,6.5,13.4,13.4,0,0,0,25.311,5.927,11.369,11.369,0,0,0,16.094-3.488,11.972,11.972,0,0,0,21.256-4.33Z",
    transform: "translate(16.194 -223.411)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31",
    "data-name": "Path 31",
    d: "M553.5,344.808a4.481,4.481,0,1,0,4.481,4.481,4.479,4.479,0,0,0-4.481-4.481",
    transform: "translate(22.754 -223.17)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32",
    "data-name": "Path 32",
    d: "M548.168,337.643a3.414,3.414,0,1,0-3.416-3.414,3.417,3.417,0,0,0,3.416,3.414",
    transform: "translate(20.189 -231.585)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33",
    "data-name": "Path 33",
    d: "M482.631,305.629a7.042,7.042,0,1,0,7.044,7.041,7.042,7.042,0,0,0-7.044-7.041",
    transform: "translate(6.579 -246.731)",
    fill: "#cee3f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34",
    "data-name": "Path 34",
    d: "M487.121,304.748c-.149,0-.288.035-.435.042a8.5,8.5,0,0,0-7.6-11.751,12.693,12.693,0,0,0-23.49-9.411,12.169,12.169,0,1,0-.455,20.334,9.126,9.126,0,0,0,12.55,8.226,8.382,8.382,0,0,0,14.387,7.948,8.449,8.449,0,0,0,5.046,1.683,8.535,8.535,0,1,0,0-17.07",
    transform: "translate(-13.126 -264.201)",
    fill: "#cee3f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35",
    "data-name": "Path 35",
    d: "M485.576,304.748c-.149,0-.288.035-.436.042a8.5,8.5,0,0,0-7.6-11.751,12.693,12.693,0,0,0-23.49-9.411,12.163,12.163,0,0,0-13.695-.058,10.745,10.745,0,0,0-1.239,5.007,11.119,11.119,0,0,0,11.232,11,11.357,11.357,0,0,0,5.94-1.677,8.377,8.377,0,0,0,8.447,8.042,8.6,8.6,0,0,0,3.144-.605,7.406,7.406,0,0,0-.383,2.247,7.705,7.705,0,0,0,7.782,7.619,7.808,7.808,0,0,0,5.883-2.681,7.924,7.924,0,0,0,11.929-3.207A8.492,8.492,0,0,0,485.576,304.748Z",
    transform: "translate(-11.677 -264.201)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36",
    "data-name": "Path 36",
    d: "M474.766,268.849a3.842,3.842,0,1,0,3.843,3.842,3.842,3.842,0,0,0-3.843-3.842",
    transform: "translate(5.098 -268.849)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37",
    "data-name": "Path 37",
    d: "M495.716,355.068a4.268,4.268,0,1,0,4.268,4.269,4.27,4.27,0,0,0-4.268-4.269",
    transform: "translate(13.703 -217)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38",
    "data-name": "Path 38",
    d: "M647.324,417.595a10.441,10.441,0,0,0-5.072-8.952,8.9,8.9,0,0,0-9.006-14.749,12.154,12.154,0,0,0-23.351,6.682,11.414,11.414,0,0,0,1.044,22.781,11.189,11.189,0,0,0,1.837-.163,10.02,10.02,0,0,0,19.157,3.619,10.456,10.456,0,0,0,15.391-9.219",
    transform: "translate(53.125 -198.649)",
    fill: "#cee3f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39",
    "data-name": "Path 39",
    d: "M600.24,406.963a12.016,12.016,0,0,0,10.9,7.169,11.727,11.727,0,0,0,1.938-.174,10.738,10.738,0,0,0,10.558,10.415,10.578,10.578,0,0,0,9.655-6.471,10.69,10.69,0,0,0,5.206,1.35,10.841,10.841,0,0,0,8.165-3.754,10.468,10.468,0,0,0-4.838-6.855,8.9,8.9,0,0,0-9.006-14.749,12.154,12.154,0,0,0-23.351,6.682A11.418,11.418,0,0,0,600.24,406.963Z",
    transform: "translate(53.557 -198.649)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40",
    "data-name": "Path 40",
    d: "M637.987,376.124a6.615,6.615,0,1,0,6.615,6.615,6.615,6.615,0,0,0-6.615-6.615",
    transform: "translate(72.278 -204.338)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41",
    "data-name": "Path 41",
    d: "M629.963,418.1a5.121,5.121,0,1,0,5.121,5.121,5.12,5.12,0,0,0-5.121-5.121",
    transform: "translate(68.352 -179.095)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42",
    "data-name": "Path 42",
    d: "M502.717,348.757a6.615,6.615,0,1,1,6.615,6.615,6.615,6.615,0,0,1-6.615-6.615",
    transform: "translate(18.074 -224.773)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_22",
    "data-name": "Group 22",
    transform: "translate(491.759)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_43",
    "data-name": "Path 43",
    d: "M135.728,327.135c.015-47.708,11.665-103.514,16.693-130.254h0a410.074,410.074,0,0,0,7.458-75.178h0c.023-29.728-4.109-54.2-10.988-71.031h0c-6.939-16.911-16.4-25.717-26.793-25.649h0a19.005,19.005,0,0,0-3.093.241h0l-.64-3.974a22.439,22.439,0,0,1,3.733-.309h0c25.89.655,41.642,40.754,41.823,100.722h0a413.959,413.959,0,0,1-7.541,75.931h0c-5.042,26.778-16.618,82.4-16.618,129.5h0c-.015,21.8,2.506,41.732,9.1,55.934h0c6.668,14.217,16.813,22.639,33.228,22.7h0c.723,0,1.437-.015,2.205-.023h0l.128,4.019c-.8.03-1.565.045-2.333.045h0c-36.4-.233-46.308-38.812-46.361-82.674ZM118.99,25.262h0Z",
    transform: "translate(233.819 44.301)",
    fill: "#282626"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44",
    "data-name": "Path 44",
    d: "M101.324,23.619c1.468.414,4.937,4.3,4.937,5.035s-3.47,1.994-4.734,2.107c-1.257.1-2.092-4-2.205-5.042C99.224,24.665,101.324,23.619,101.324,23.619Z",
    transform: "translate(109.52 61.524)",
    fill: "#d3a994"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_45",
    "data-name": "Path 45",
    d: "M104.577,37.851c1.377-1.114,3.966-11.583,4.328-12.644s.677-2.009-2.04-.745c-2.717,1.294-7.15,10.725-6.382,11.982S104.577,37.851,104.577,37.851Z",
    transform: "translate(116.547 63.066)",
    fill: "#e5c0ae"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46",
    "data-name": "Path 46",
    d: "M97.189,51.87c5.253-1.513,30.767-25.017,33.032-25.762,2.258-.76,7.157,26.906,7.157,26.906s-25.355,22.736-30.631,21.231S97.189,51.87,97.189,51.87Z",
    transform: "translate(95.622 77.669)",
    fill: "#e5c0ae"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47",
    "data-name": "Path 47",
    d: "M135.064,24.286c-12.012,7.014-31.58,26.3-36.946,30.135,8.723,9.874,18.319,23.248,18.319,23.248s27.892-27.553,25.574-37.563A42.647,42.647,0,0,0,135.064,24.286Z",
    transform: "translate(101.685 65.877)",
    fill: "#cbcbcb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48",
    "data-name": "Path 48",
    d: "M101.351,48.357c-10.168-7.91-10.634-15.647-9.242-17.4s12.877-7.421,15.368-6.518,5.246,13.938,5.035,15.541C112.3,41.606,101.351,48.357,101.351,48.357Z",
    transform: "translate(58.729 66.243)",
    fill: "#e5c0ae"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49",
    "data-name": "Path 49",
    d: "M92.44,32.226c1.4,1.829,7.624,9.3,9.927,11.793,8.279,9.039,22.157,25.371,28.494,28.629,6.352,3.266,12.26-.369,12.433-2.378s-3.929-21.833-3.929-21.833S117.788,34.988,105.234,26.7C101.735,24.391,92.44,32.226,92.44,32.226Z",
    transform: "translate(64.629 78.859)",
    fill: "#e5c0ae"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50",
    "data-name": "Path 50",
    d: "M104.318,44.951c.384-4.139,2.431-6.36,1.377-10.424-1.061-4.049-1.377-4.591-1.648-5.614-1.392-5.223-1.814-4.629-1.814-4.629s-2.6-.783-1.761,4.9a6.869,6.869,0,0,1-1.031,4.666c-.5.948-6.653,4.644-6.608,7.624s1.407,7.007,3.485,7.067C98.425,48.6,104.318,44.951,104.318,44.951Z",
    transform: "translate(67.194 65.63)",
    fill: "#e5c0ae"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_14",
    "data-name": "Group 14",
    transform: "translate(219.032 217.973)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_51",
    "data-name": "Path 51",
    d: "M167.155,70.271c.647,6.307,3.861,24.513,1.641,33.122-.76,2.98-8.241,1.415-12.952,2.416-1.934.429-8.783-.045-12.252,1.136-12.614,4.3-32.362,1.272-34.7-.083-2.333-1.392-2.965-11.854,3.876-16.52,5.4-3.658,22.2-5.11,24.151-9.167,1.927-4.042,5.261-14.014,5.261-14.014Z",
    transform: "translate(-57.597 127.723)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52",
    "data-name": "Path 52",
    d: "M100.673,58.96s9.633,29.721,22.842,63.844c3.613,9.37,20.095,56.694,25.867,61.646,5.788,4.952,18.161,69.9,18.161,69.9s47.61,14.857,50.922,9.084-15.413-91.367-31.113-105.411c-11.538-47.874-36.314-105.667-45.405-114.758C132.877,34.191,100.673,58.96,100.673,58.96Z",
    transform: "translate(-100.673 -41.268)",
    fill: "#efeef0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_53",
    "data-name": "Path 53",
    d: "M102.247,60.457c13.193,19.809,26.959,52.284,31.9,57.778,4.96,5.509,4.96,5.231,8.271,12.388,3.3,7.157,14.849,63.024,14.849,63.024s11.011,5.78,21.2,6.6c6.42.519-45.42-126.6-55.324-143.109S102.247,60.457,102.247,60.457Z",
    transform: "translate(-90.401 19.438)",
    fill: "#cbcbcb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_15",
    "data-name": "Group 15",
    transform: "translate(131.02 185.21)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_54",
    "data-name": "Path 54",
    d: "M151.831,73.3c0,6.352,1.34,24.776-1.746,33.122-1.061,2.9-8.346.58-13.118,1.084-1.987.233-8.738-.948-12.313-.113-13.005,2.988-32.34-2.025-34.522-3.605-2.175-1.626-1.761-12.1,5.547-16.046,5.727-3.1,22.616-2.83,24.941-6.668,2.341-3.816,6.668-13.4,6.668-13.4Z",
    transform: "translate(-88.979 163.815)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55",
    "data-name": "Path 55",
    d: "M152.194,37.284C144.51,58.2,150.553,63.708,146.7,82.967c0,0-15.549,101.828-23.805,119.989s-29.721,84.413-29.721,84.413,29.307,19.4,37.57,19.4c8.249,0,34.244-97.84,35.9-104.237,11.568-44.577,26.838-64.8,38.4-91.232,11.56-26.409,15.082-37.871,7.15-58.056S152.194,37.284,152.194,37.284Z",
    transform: "translate(-61.601 -36.915)",
    fill: "#efeef0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_56",
    "data-name": "Path 56",
    d: "M147.012,37.365c0,10.74,3.161,31.519,2.062,38.413-1.1,6.856-20.674,88.372-21.472,97.809-2.469,29.736-35.087,107.337-35.087,107.337s16.934,13.2,19.417,10.732c2.453-2.476,25.581-89.169,33.017-112.29S161.582,91.4,166.406,81.129c4.839-10.281,4.967-30.27,1.656-36.05S147.012,37.365,147.012,37.365Z",
    transform: "translate(-65.901 -33.978)",
    fill: "#cbcbcb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_16",
    "data-name": "Group 16",
    transform: "translate(206.298)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_57",
    "data-name": "Path 57",
    d: "M130.664,18.463c.873,5.118,2.86,9.822,6.623,17.528,7.466,15.293,6.917,17.972,6.917,17.972L119.3,66.291S109.508,43.721,103.623,40.2C97.715,36.706,130.664,18.463,130.664,18.463Z",
    transform: "translate(-73.315 27.875)",
    fill: "#d3a994"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_58",
    "data-name": "Path 58",
    d: "M101.135,57.871c1.309-2.612,1.716-10.311,2.311-12.177-.008-.06,0-.135-.038-.181A24.2,24.2,0,0,1,101.8,24.861c.226-.557,2.694-.316,3.808-1.182,7.5-12.569,44.306-16.941,48.634,4.147,8.158,39.6-28.471,48.077-37.194,49.68-1.581.286-4.967-.324-6.774-7.955a44.875,44.875,0,0,1-4.124-8.038c-2.581-.414-4.606-1.5-4.892-2.958A1.2,1.2,0,0,1,101.135,57.871Z",
    transform: "translate(-91.08 -6.919)",
    fill: "#d3a994"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_59",
    "data-name": "Path 59",
    d: "M154.554,19.207c-4.124-2.74-6.6-9.212-18.695-6.051-10.4,2.7-22.721,4.523-26.522,13.607-3.552,8.5-10.356,7.345-10.356,7.345a9.165,9.165,0,0,0,7.075,7.428c2.589.534,13.163-5.328,17.212-1.249a27.827,27.827,0,0,0,8.783,5.374s9.987,3.778,10.672,7.127c.241,1.129,3.823,8.851,6.4,11.1,5.155,4.471,15.06,5.675,15.06,5.675s-1.46-7.586,1.091-23.083C168.281,28.156,160.59,23.211,154.554,19.207Z",
    transform: "translate(-98.981 -12.306)",
    fill: "#070d41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_60",
    "data-name": "Path 60",
    d: "M103.992,21.806c-2.2-8.836,7.187-5.4,7.662-2.777.542,2.928,4,10.175-.309,13.156C107.077,35.18,103.992,21.806,103.992,21.806Z",
    transform: "translate(-68.453 12.558)",
    fill: "#d3a994"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_61",
    "data-name": "Path 61",
    d: "M148.4,26.188a26.384,26.384,0,0,1,13.66-4.576c24.46,20.012,18.763,35.659,9.122,67.81-6.487,21.585,8.836,46.225-10.853,54.67-19.605,8.407-50.417,4.8-51.591,3.221-18.221-24.656-5.637-82.546,15.8-106.66C127.645,37.154,134.456,35.287,148.4,26.188Z",
    transform: "translate(113.792 48.425)",
    fill: "#ebf1ea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62",
    "data-name": "Path 62",
    d: "M161.764,20.662c-3.613,4.809-12.268,12.448-21.909,22.5-8.038,8.369-13.532,21.374-13.532,21.374s-6.42,1.069-15.015-2.137c-13.4,27.869-13.4,74.5-9.114,88.439,1.565,5.05,21.457,8.053,21.457,8.053l48.22-5.908,3.357-9.521c-3.221-.534-21.577-46.225-21.577-46.225l-20.832-5.027c8.053-40.739,15.669-47.648,34.974-62.723Z",
    transform: "translate(111.749 42.226)",
    fill: "#a2a2a2"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_20",
    "data-name": "Group 20",
    transform: "translate(0 64.444)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63",
    "data-name": "Path 63",
    d: "M330.551,27.336,87.268,67.936l-.989-6.464,243.291-40.6Z",
    transform: "translate(24.421 -20.869)",
    fill: "#353535"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_700",
    "data-name": "Path 700",
    d: "M-148.487,1511.307l-90.086,41.329L-254,1491.5l103.417,6.666Z",
    transform: "translate(254 -1460.723)",
    fill: "url(#linear-gradient-11)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_19",
    "data-name": "Group 19",
    transform: "translate(102.485 36.963)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_17",
    "data-name": "Group 17",
    transform: "translate(0.251)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_64",
    "data-name": "Path 64",
    d: "M86.578,39.139c.188,1.294,1.287.79,2.943.557l.5-.06c1.656-.233,2.845-1.483,2.672-2.792l-1.257-9.069c-.181-1.317-1.671-2.19-3.327-1.957l-.5.068c-1.656.241-2.551,2.664-2.363,3.974Z",
    transform: "translate(-85.221 -25.78)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65",
    "data-name": "Path 65",
    d: "M85.983,26.011c1.618-.233,5.66-.113,7.361,1.167.662,4.726.881,6.314.881,6.314s-.226,2.3-7.857,3.62C85.863,37.2,85.983,26.011,85.983,26.011Z",
    transform: "translate(-80.329 -24.897)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_18",
    "data-name": "Group 18",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_66",
    "data-name": "Path 66",
    d: "M98.205,27.895c-1.9-1.069-5.148-1.227-6.924-1.024a3.111,3.111,0,0,0-2.95-1.054l-.5.068c-1.656.241-2.807-.376-2.619.926l.655,5.712,12.907-1.678Z",
    transform: "translate(-85.187 -25.78)",
    fill: "#353535"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_21",
    "data-name": "Group 21",
    transform: "translate(150.617 89.964)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_67",
    "data-name": "Path 67",
    d: "M97.57,24.661c-.948-.143-4.478-1.325-4.516,1.189-.015,1.422,2.348,10.311,4.471,10.1,2.16-.233,1.475-.76,1.483-3.6A35.643,35.643,0,0,0,97.57,24.661Z",
    transform: "translate(-81.981 -24.26)",
    fill: "#d3a994"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_68",
    "data-name": "Path 68",
    d: "M97.393,24.752c-.993-.617-4.915-.805-4.982,1.34s2.25,10.544,4.764,10.762c2.491.2,2.461-2,2.168-4.817A40.619,40.619,0,0,0,97.393,24.752Z",
    transform: "translate(-86.192 -23.741)",
    fill: "#d3a994"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69",
    "data-name": "Path 69",
    d: "M95.64,24.572c-2.732.519-3.913,1.129-3.7,3,.188,1.874,1.927,7.993,4.117,8.234s2.228-1.987,1.242-5.441S95.64,24.572,95.64,24.572Z",
    transform: "translate(-89.421 -22.221)",
    fill: "#d3a994"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_70",
    "data-name": "Path 70",
    d: "M94.3,24.989c-1.234.03-2.792-.158-2.717,2.085s2.589,6.969,3.643,6.615,1.453-2.4.775-4.35S94.3,24.989,94.3,24.989Z",
    transform: "translate(-91.583 -19.5)",
    fill: "#d3a994"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_71",
    "data-name": "Path 71",
    d: "M176.093,30.293c-4.982-.263-15.684,33.6-21.126,38.1-3.184-4.952-28.486-25.024-29.051-26.1-.068-3.8-.685-8.527-1.347-9.34-.339-.421-2.122-.549-4.17-1.633-2.521-1.332-4.109-4.328-5.148-5.328-.4-.843-.67-1.535-.331-1.535.73,0-1.392-1.573-3.944-.534-.971.406-.76,1.325-.918,1.829a3.35,3.35,0,0,0-1.234-.775c-1.889-.738-4.425.82-3.725,3.206-.489-1.468-2.566-1.874-4.252-.2a2.4,2.4,0,0,0-.467,1.761c-.677-.5-1.52-.2-2.612.482-1.114.7.2,4.967.354,5.8.271,2.318,1.889,7,13.02,16.038C131.29,86.5,149.624,93.814,153.131,94.9c11.545,3.567,30.225-22.955,30.225-22.955S181.083,30.579,176.093,30.293Z",
    transform: "translate(96.502 61.164)",
    fill: "#e5c0ae"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72",
    "data-name": "Path 72",
    d: "M135.663,24.07c-7.059-2.28-15.948,7.315-19.718,14.533-3.771,7.233-8.136,18.921-10.8,22.247C111.58,69.625,133.2,80.561,133.2,80.561s11.387-18.635,13.863-31.4C151.017,28.871,135.663,24.07,135.663,24.07Z",
    transform: "translate(147.544 62.232)",
    fill: "#cbcbcb"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeimage);
export default __webpack_public_path__ + "static/media/homeimage.8b6bda9f079ee3c29bbd083c78f4a331.svg";
export { ForwardRef as ReactComponent };